import { render } from "./FormCouple.vue?vue&type=template&id=5b71a56e"
import script from "./FormCouple.vue?vue&type=script&lang=js"
export * from "./FormCouple.vue?vue&type=script&lang=js"

import "./FormCouple.vue?vue&type=style&index=0&id=5b71a56e&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__